/**
 * TitleAndButton compponent
 * @returns <TitleAndButton />
 */

import Button from "./Button";

const TitleAndButton = (props) => {
    const { title, title2, subtitle, color, buttons, backgroundColor } = props;

    return (
        <div className="title-and-button store-padding" style={{ backgroundColor: backgroundColor ? backgroundColor : "" }}>
            <div className="wrapper">
                <span className="text" style={{ color: color }}>
                    {/* TODO: de aca borre un linebreak que estaba con 1 pipe */}
                    <h1 dangerouslySetInnerHTML={{ __html: title }}></h1>

                    {/* TODO: de aca borre un linebreak que estaba con 1 pipe */}
                    {title2 && <h1 className="title2">{title2}</h1>}

                    {subtitle && <p className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle }}></p>}
                </span>

                {buttons.length > 0 &&
                    buttons.map((button, i) => {
                        return <Button {...button.config} key={i} />
                    })
                }
            </div>
        </div>
    )
}

export default TitleAndButton
